export default __webpack_public_path__ + "static/media/phpback.d1753a97.svg";